<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">Planillas</h1>
    </div>
    <div class="table-container">
      <div class="table-header">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative"
        >
          <div class="w-full w-md-auto md-flex-1">
            <div
              class="d-flex justify-content-between align-items-center justify-content-lg-start"
            >
              <button
                type="button"
                class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters"
              >
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-md-none">
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold m-0"
                  v-b-tooltip.hover
                  title="Recargar"
                  @click="loadData()"
                >
                  <i class="ri-loop-right-line"></i>
                </button>
                <!-- <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold mr-0"
                  v-b-tooltip.hover
                  title="Descargar"
                  @click="downloadReport()"
                >
                  <i class="ri-download-2-line"></i>
                </button> -->
              </div>
            </div>
          </div>

          <section
            class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0"
          >
            <div class="d-none d-md-flex">
              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover
                title="Recargar"
                @click="loadData()"
              >
                <i class="ri-loop-right-line"></i>
              </button>

              <!-- <button
                type="button"
                class="button-tooltip text-dark font-weight-bold ml-0"
                v-b-tooltip.hover
                title="Descargar"
                @click="downloadReport()"
              >
                <i class="ri-download-2-line"></i>
              </button> -->
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar
                placeholder="Buscar por nombre de planilla"
                @search="onSearch"
                @input="search = $event"
                class="flex-1"
              />

              <div class="text-right mt-2 mt-md-0">
                <b-button
                  variant="none"
                  class="button button-primary ml-md-2"
                  >Agregar</b-button
                >
              </div>
            </div>
          </section>

          <filter-menu
            :show="showFilters"
            @hide="showFilters = false"
            :options="filterOptions"
            :selectedOptionFilter="filters"
            @setFilters="setFilters"
          ></filter-menu>
        </div>

        <div
          class="w-100 d-flex flex-wrap align-items-center mt-2"
          v-if="showFiltersList"
        >
          <span
            v-for="(val, name) in filterList"
            v-bind:key="name"
            class="filter-item"
          >
            {{ getFilterName(name, val) }}
            <button
              type="button"
              class="text-white p-0 bg-transparent border-0 ml-2"
              @click="deleteFilter(name)"
            >
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div>
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>Código de Planilla</span>
            </div>

            <div>
              <span>Periodo</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span>{{ o.code }}</span>
                </div>

                <div>
                  <span>{{ o.period }}</span>
                </div>

                <div>
                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="custom-table-mobile-options mt-3">
                <router-link
                  :to="{ name: 'payroll-details', params: { id: o.id } }"
                  class="mx-3"
                >
                  Ver detalle
                </router-link>
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Nombre de Planilla:</span
                    >
                    <span>{{ o.name }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Tipo:</span
                    >
                    <span>{{ o.type }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Cantidad de Colaboradores:</span
                    >
                    <span>{{ o.collaborators }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Monto Total a Pagar:</span
                    >
                    <span v-decimal:pen="o.totalAmount"></span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Abonados:</span
                    >
                    <span>{{ o.paid }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Total Pagado:</span
                    >
                    <span>{{ o.totalPaid }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Progreso:</span
                    >
                    <b-progress
                      :value="o.progress"
                      max="100"
                      show-progress
                      animated
                    ></b-progress>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>
                Código de <br />
                Planilla
              </th>
              <th>Periodo</th>
              <th>Nombre de Planilla</th>
              <th>Tipo</th>
              <th>
                Cantidad de <br />
                Colaboradores
              </th>
              <th>Monto Total a Pagar</th>
              <th>Abonados</th>
              <th>Total Pagado</th>
              <th>Progreso</th>
              <!-- <th class="pr-md-3">Opciones</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="pl-2">{{ o.code }}</td>
              <td class="pl-2">{{ o.period }}</td>
              <td class="pl-2">{{ o.name }}</td>
              <td class="pl-2">{{ o.type }}</td>
              <td class="cell-center pl-2">{{ o.collaborators }}</td>
              <td class="cell-center pl-2">
                <span v-decimal:pen="o.totalAmount"></span>
              </td>
              <td class="cell-center pl-2">{{ o.paid }}</td>
              <td class="cell-center pl-2">
                <span v-decimal:pen="o.totalPaid"></span>
              </td>
              <td class="cell-center pl-md-2">
                <b-progress
                  :value="o.progress"
                  max="100"
                  show-progress
                  animated
                ></b-progress>
              </td>
              <!-- <td class="cell-center d_option pr-md-2 position-relative">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem
                      text="Ver detalle"
                      :to="{
                        name: 'payroll-details',
                        params: { id: o.id },
                      }"
                    />
                  </template>
                </DropdownTable>
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination
          :total="total"
          :page="page"
          :page-size="pageSize"
          :pages="pages"
          :changePage="changePage"
          :changePageSize="changePageSize"
          v-if="list.length"
        />

        <div class="table-no-results" v-else>
          <p class="m-0 px-3">No se encontraron resultados.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Constants,
  Util,
  Alert,
  FilterMenu,
  FilterMixin,
  PaginationMixin,
  // DropdownTable,
  // DropdownItem,
  SearchBar
} from "wize-admin";

import { BProgress } from "bootstrap-vue";

import { Constants as LocalConstants, Utils } from "@/core/utils";
import { PayrollService } from "@/core/services";
import fileDownload from "js-file-download";

export default {
  mixins: [PaginationMixin, FilterMixin],
  components: {
    SearchBar,
    // DropdownTable,
    // DropdownItem,
    FilterMenu,
    BProgress
  },
  data() {
    return {
      list: [],
      AreaStatus: LocalConstants.AreaStatus,
      tooltipType: null,
      filterOptions: [
        {
          label: "Tipo de planilla",
          key: "type",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.PayrollTypes.OPERATORS,
            LocalConstants.PayrollTypes.ADMINISTRATORS
          ],
        },
        {
          label: "Periodo",
          key: "period",
          type: Constants.TypeFilters.SINGLE,
          options: [],
        }
      ],
    };
  },
  methods: {
    setPeriods() {
      const periods = Utils.generatePeriods();
      this.filterOptions[1].options = periods.map((item) => {
        return {
          key: item,
          label: item,
        };
      });
    },
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);
        const params = {
          page: this.page - 1,
          size: this.pageSize,
          sort: "id",
        };
        const data = { search: this.search, ...this.filters };
        const response = await PayrollService.list(data, params);

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false,
          };
        });

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    getStatus(key) {
      let keyInt = parseInt(key);
      return Util.searchValue(keyInt, LocalConstants.AreaStatus);
    },
    async downloadReport() {
      try {
        await this.$store.dispatch("app/loading", true);
        const data = { search: this.search, ...this.filters };
        const response = await PayrollService.download(data);
        fileDownload(response.data, Util.getFileName(response));
      } catch (error) {
        console.error(error);
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
  },
  async created() {
    this.setPeriods();
    await this.loadData(this.page, this.pageSize);
  },
};
</script>

<style lang="stylus">
@import '../Styles/supplier-list';
</style>
